// Polyfills for Node.js globals in browser environment

// Polyfill for process
if (typeof globalThis.process === 'undefined') {
  globalThis.process = {
    env: {},
    nextTick: (callback: (...args: unknown[]) => void) =>
      setTimeout(callback, 0),
    version: '',
    versions: {},
    platform: 'browser',
    browser: true,
  } as typeof globalThis.process;
}

// Polyfill for global
if (typeof globalThis.global === 'undefined') {
  globalThis.global = globalThis;
}

// Export empty object to make this a module
export {};
